import { useLocale } from '@adsk/alloy-react-locale';

const ScheduleActivityNestedOptionsLabel = () => {
  const { T } = useLocale(({ locale }) => require(`../../i18n/${locale}.json`));

  return T.translate('SCHEDULE');
};

export default ScheduleActivityNestedOptionsLabel;
